import * as React from 'react';

// @NOTE This is the updated html icon being less bolded, to be removed once we update Flame to the latest version
export const IconHelp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    style={{ width: '14px', height: '14px', color: '#999' }}
  >
    <g id="help">
      <path
        id="base-1"
        fill="#555"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      />
      <path
        id="details-1"
        fill="#555"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.01096 6.323H5.25C5.26508 4.918 6.29532 4 8.02915 4C9.67654 4 10.75 4.858 10.75 6.146C10.75 6.94 10.3761 7.488 9.57904 7.943C8.83726 8.368 8.63121 8.609 8.63121 9.113V9.366H6.94061L6.92452 9.15C6.81999 8.233 7.09137 7.75 7.84521 7.32C8.58096 6.891 8.77193 6.666 8.77193 6.194C8.77193 5.759 8.41411 5.459 7.90552 5.459C7.38487 5.459 7.02705 5.803 7.01096 6.323ZM8.93879 11.023C8.93879 11.64 8.53373 12 7.83316 12H7.83417C7.13561 12 6.72351 11.641 6.72351 11.023C6.72351 10.401 7.13561 10.043 7.83316 10.043C8.53373 10.043 8.93879 10.401 8.93879 11.023Z"
      />
    </g>
  </svg>
);
